import React, { useState , useMemo } from 'react';
import ReactFlowContainer from './ReactFlowContainer';
import RightPanel from './RightPanel';
import { useSelector } from 'react-redux';
import { MarkerType, ReactFlowProvider } from '@xyflow/react';
import { ParentScreenCtx } from '/src/pages/workbench_build/WorkbenchBuild';

const VisualWorkflow = () => {
  const [rightPanelOpen, setRightPanelOpen] = useState(true);

  const workflow = useSelector(state => state?.treeData?.workflow?.rightTree?.tree?.body?.translatedData?.[0]);
  const rightTreeSelectedNode = useSelector((state) => state.treeData.workflow.rightTree.tree.body.selectedNode);
  
  const { nodes, edges } = useMemo(() => generateNodeAndEdges(workflow), [workflow]);

  function generateNodeAndEdges(workflow, initialNodes = [], initialEdges = []) {
    const nodes = [...initialNodes];
    const edges = [...initialEdges];
    
    // Add start node
    nodes.push({
      id: workflow?.alternateNodeId || 'start',
      type: 'customNode',
      data: { label: 'Start', type: "START", data: workflow || {} },
      position: { x: workflow?.POSITIONX || 0, y: workflow?.POSITIONY || 0 },
      selected: workflow?.alternateNodeId === rightTreeSelectedNode?.alternateNodeId
    });
    
    // If no children or no workflow, return just the start node
    if (!workflow || !workflow.children || workflow.children.length === 0) {
      return { nodes, edges };
    }

    function findParentID(child, children, initialParentId){
      let reversedChildren = [...children.slice(0, children.indexOf(child))].reverse();
      let parentId = initialParentId;
      for (const child of reversedChildren) {
        if (
          child?.CONCURRENT !== "TRUE" 
        ) {
          parentId = child?.alternateNodeId;
          break;
        }
      }      

      return parentId;
    }

    function processChildren(children, parentId, isParentIf = false, isParentElse = false) {
      
      let isParentIfState = isParentIf;
      let isParentElseState = isParentElse;
      children.forEach((child, _) => {
        const calculatedParentId = findParentID(child, children, parentId);
        
        if(child?.children?.length > 0) {
          processChildren(child?.children, child?.alternateNodeId, child?.ICON_DISPLAY === "CONDITION_IF", child?.ICON_DISPLAY === "CONDITION_ELSE");
        }

        nodes.push({
          id: child?.alternateNodeId,
          type: 'customNode',
          data: { label: child?.title, type: child?.ICON_DISPLAY, data: (({ POSITIONX, POSITIONY, ...rest }) => rest)(child || {})},
          position: { x: child?.POSITIONX || 0, y: child?.POSITIONY || 0 },
          selected: child?.alternateNodeId === rightTreeSelectedNode?.alternateNodeId
        });
        
        edges.push({
          id: `${calculatedParentId}-${child?.alternateNodeId}`,
          source: calculatedParentId,
          target: child?.alternateNodeId,
          type: 'smooth',
          markerEnd: {
            type: MarkerType.ArrowClosed,
            color: child?.CONCURRENT === "TRUE" ? '#0066ff' : '#555'
          },
        style: { 
          stroke: child?.CONCURRENT === "TRUE" ? '#0066ff' : '#555',
          strokeWidth: child?.CONCURRENT === "TRUE" ? 3 : 2
        },
        animated: child?.CONCURRENT === "TRUE",
        label: child?.ICON_DISPLAY === "CONDITION_ELSE" ? 'FALSE' : isParentIfState || isParentElseState ? 'TRUE' : null,
        });

        isParentIfState = false;
      })
    }

    if(workflow?.children?.length > 0) {
      processChildren(workflow?.children, workflow?.alternateNodeId || 'start');
    }

    return { nodes, edges };
  }

  const handleToggleRightPanel = () => {
    setRightPanelOpen(!rightPanelOpen);
  };

  return (
    <ParentScreenCtx.Provider value="workflow">
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <ReactFlowProvider>
          <ReactFlowContainer initialNodes={nodes} initialEdges={edges} />
        </ReactFlowProvider>
        <RightPanel open={rightPanelOpen} onToggle={handleToggleRightPanel} />
      </div>
    </ParentScreenCtx.Provider>
  );
}

export default React.memo(VisualWorkflow);